import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Tabs, Box } from "orcs-design-system";
import { PERSON_TAB } from "src/consts/urlPaths";
import { useAllocationProject } from "src/contexts/global/GlobalContext";
import { useAllocationConfig } from "src/contexts/global/WorkspaceContext";
import useUserRole from "src/app/Restricted/useUserRole";
import { DIRECTORY_ROLE } from "src/services/auth";

const PersonTabs = ({ userHomeMode, person }) => {
  const userRole = useUserRole();
  const detailsTabName = userHomeMode ? "My Details" : "Person Details";
  const allocationsTabName = userHomeMode ? "My Allocations" : "Allocations";
  const { disableIndividualAllocation } = useAllocationConfig();
  const activeAllocationProject = useAllocationProject();
  const allocationPermission = get(
    person,
    "permissions.isInAccessGroupIdsHierarchy"
  );

  const isDirectoryUserHome = userRole === DIRECTORY_ROLE && userHomeMode;

  const isIndividualAllocationEnabled = !!(
    activeAllocationProject &&
    allocationPermission &&
    !disableIndividualAllocation
  );

  const isMembershipsEnabled = !!(
    allocationPermission && !disableIndividualAllocation
  );

  const personTabsList = useMemo(() => {
    const tabs = [
      {
        label: "Dashboard",
        path: PERSON_TAB.USER_DASHBOARD,
        isVisible: !!userHomeMode,
      },
      {
        label: detailsTabName,
        path: PERSON_TAB.DETAILS,
      },
      {
        label: allocationsTabName,
        path: PERSON_TAB.ALLOCATIONS,
        isVisible:
          !isDirectoryUserHome &&
          isIndividualAllocationEnabled &&
          !isMembershipsEnabled,
      },
      {
        label: allocationsTabName,
        path: PERSON_TAB.ALLOCATIONS,
        isVisible: !isDirectoryUserHome && isMembershipsEnabled,
      },
      {
        label: "History",
        path: PERSON_TAB.HISTORY,
        isVisible: !isDirectoryUserHome,
      },
    ];

    return tabs;
  }, [
    userHomeMode,
    detailsTabName,
    allocationsTabName,
    isIndividualAllocationEnabled,
    isMembershipsEnabled,
    isDirectoryUserHome,
  ]);

  return (
    <Box boxBorder="default" borderX="none" borderBottom="none">
      <Tabs tabsList={personTabsList} />
    </Box>
  );
};

PersonTabs.propTypes = {
  userHomeMode: PropTypes.bool,
  person: PropTypes.object,
};

export default PersonTabs;
